interface LoneParticipantDialogProps {
  open: boolean;
  onEndCall: () => void;
  onSnooze: () => void;
}

/**
 * "You're the only one here — end the call?" prompt shown after the local user
 * has been alone in a call for a while. Styling mirrors the terminal reconnect
 * dialog in CallSessionRoom.tsx.
 */
export function LoneParticipantDialog({
  open,
  onEndCall,
  onSnooze,
}: LoneParticipantDialogProps) {
  if (!open) return null;
  return (
    <div
      role="alertdialog"
      aria-modal="true"
      data-testid="lone-participant-dialog"
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ zIndex: 9999, background: "rgba(0,0,0,0.6)" }}
    >
      <div
        className="w-full max-w-sm rounded-xl p-6 text-center shadow-2xl"
        style={{
          background: "var(--bg-root, #12161f)",
          color: "var(--text-primary, #fff)",
          border: "1px solid var(--border-hover, rgba(255,255,255,0.12))",
        }}
      >
        <h2 className="mb-2 text-lg font-semibold">You’re the only one here</h2>
        <p
          className="mb-5 text-sm"
          style={{ color: "var(--text-secondary, rgba(255,255,255,0.7))" }}
        >
          Everyone else has left the call. End it now, or keep waiting?
        </p>
        <div className="flex items-center justify-center gap-3">
          <button
            type="button"
            data-testid="lone-end"
            onClick={onEndCall}
            className="rounded-lg px-4 py-2 text-sm font-medium"
            style={{ background: "#e5484d", color: "#fff" }}
          >
            End call
          </button>
          <button
            type="button"
            data-testid="lone-snooze"
            onClick={onSnooze}
            className="rounded-lg px-4 py-2 text-sm font-medium"
            style={{
              background: "transparent",
              color: "var(--text-secondary, rgba(255,255,255,0.7))",
              border: "1px solid var(--border-hover, rgba(255,255,255,0.15))",
            }}
          >
            Wait 5 more minutes
          </button>
        </div>
      </div>
    </div>
  );
}
